import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastService } from '../../../base/services/toast.service';
import { SpinnerService } from '../../../base/spinner/spinner.service';
import { ClientClient, ClientDTO, PagedResultDTOOfClientDTO, CreateClientDTO, UpdateClientDTO, FilterDTO, SortDirection } from '../../../base/models/models.swagger.generated';
import { ErrorType } from '../../../core/routing/error-types';
import { PagedQueryModel } from '../../../base/shared/table/paged-query-model';
import { IPagedItems } from 'src/app/base/shared/table/paged-items.interface';
import { AuthService } from 'src/app/base/services/auth.service';


@Injectable()
export class ClientAdministrationService {
  constructor(
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private authService: AuthService
  ) { }

  public getData(pagedQuery: PagedQueryModel): Observable<IPagedItems> {
    this.spinnerService.showSpinner = true;
    return this.clientAdministrationClient.searchClients(pagedQuery.filters, pagedQuery.skip, pagedQuery.take, pagedQuery.sortBy, pagedQuery.sortDirection)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: UpdateClientDTO): Observable<ClientDTO> {
    this.spinnerService.showSpinner = true;
    return this.clientAdministrationClient.updateClient(data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.messages.update-title', 'i18n.domain.client-administration.messages.update-success-message');
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: CreateClientDTO): Observable<ClientDTO> {
    this.spinnerService.showSpinner = true;
    return this.clientAdministrationClient.createClient(data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.messages.add-title', 'i18n.domain.client-administration.messages.add-success-message');
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public deleteRecord(id: number): Observable<any>
   {
    this.spinnerService.showSpinner = true;
    return this.clientAdministrationClient.deactivateClient(id)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.domain.client-administration.messages.delete-title',
            'i18n.domain.client-administration.messages.delete-success-message');
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError(
              'i18n.errors.server-error.title',
              'i18n.errors.server-error.message',
              null,
              ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
public getMyClient(): Observable<ClientDTO> {
  const clientId = this.authService.getUserInfo()?.client?.id;

  if (!clientId) {
    return throwError(() => new Error('Client not found for user'));
  }

  this.spinnerService.showSpinner = true;

  return this.clientAdministrationClient.getClient(clientId).pipe(
    tap(() => {
      this.spinnerService.showSpinner = false;
    }),
    catchError((error: any) => {
      this.spinnerService.showSpinner = false;
      if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
        this.toastService.showError(
          'i18n.errors.server-error.title',
          'i18n.errors.server-error.message',
          null,
          ErrorType.serverError
        );
      }
      return throwError(() => error);
    })
  );
}


}

